module.exports = __webpack_public_path__ + "static/media/alerta-acao-preparatoria.a7261757.svg";